import SiteFooter from '@/components/feature/SiteFooter';
import SiteNavbar from '@/components/feature/SiteNavbar';
import {
  Compliance,
  ExportMapSection,
  GlobalReachCta,
  GlobalReachHero,
  KeyMarkets,
  Logistics,
  RegionStats,
} from './components/Sections';

export default function GlobalReach() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <GlobalReachHero />
        <ExportMapSection />
        <RegionStats />
        <KeyMarkets />
        <Logistics />
        <Compliance />
        <GlobalReachCta />
      </main>
      <SiteFooter />
    </div>
  );
}